import { forwardRef } from 'react'
import { Input, InputProps } from '@chakra-ui/react'
import cx from 'classnames'
import styles from './styles.module.scss'

interface TextFieldProps extends InputProps {
  isOpen?: boolean
  targetHover?: boolean

  type?: 'text' | 'email' | 'password' | 'textarea' | 'number'
  error?: boolean

  className?: string
  name?: string
  autoComplete?: string
}

const TextField = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const { className = '', error = false, type = 'text', autoComplete, ...rest } = props
  const classes = [styles.hfTextField, 'form-control']

  if (error) classes.push(styles.errorWrapper)
  return (
    <Input
      ref={ref}
      type={type}
      className={cx(...classes, className)}
      colorScheme="white"
      background="white"
      fontSize="0.9rem"
      {...(autoComplete && { autoComplete })}
      {...rest}
    />
  )
})
export default TextField
